const DEFAULT_API_BASE_URL = 'https://api.bridgex.global';

export const environment = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') || DEFAULT_API_BASE_URL,
};


